import { Injectable } from '@angular/core';

@Injectable()
export class MaintenanceService {
  constructor() {}

  public maintenanceData: any;

  getMaintenanceData() {
    return this.maintenanceData;
  }
  putMaintenanceData(data) {
    this.maintenanceData = data;
  }
}
